import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getWalletByUser = createAsyncThunk(
    'wallet/getWalletByUser',
    async (_, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/wallet/find-wallet-by-user`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getWalletDetailsByUser = createAsyncThunk(
    'wallet/getWalletDetailsByUser',
    async (_, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/wallet/find-wallet-by-user`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const submitWithrawalRequest = createAsyncThunk(
    'wallet/submitWithrawalRequest',
    async (withdrawalData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(withdrawalData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/withdrawal-requests/create-withdrawal-request`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getAllWalletTransactions = createAsyncThunk(
    'wallet/getAllWalletTransactions',
    async ({ wallet_transaction_type, wallet_operation_type, skip, limit, status }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params: {
                    ...(wallet_transaction_type ? { wallet_transaction_type } : {}),
                    ...(wallet_operation_type ? { wallet_operation_type } : {}),
                    ...(skip ? { skip: skip - 1 } : {}),
                    ...(limit ? { limit } : {}),
                    ...(status ? { status } : {}),
                },
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/wallet-transactions`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getAllWalletRequests = createAsyncThunk(
    'wallet/getAllWalletRequests',
    async ({ withdrawal_request_status, skip, limit, status }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params: {
                    ...(withdrawal_request_status ? { withdrawal_request_status } : {}),
                    ...(skip ? { skip: skip - 1 } : {}),
                    ...(limit ? { limit } : {}),
                    ...(status ? { status } : {}),
                },
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/withdrawal-requests`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const cancelWithrawalRequest = createAsyncThunk(
    'wallet/cancelWithrawalRequest',
    async (requestData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(requestData);

            const response = await axios.put(`${PUBLIC_BASE_URL}/withdrawal-requests/close-withdrawal-request`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getNewWalletTransactions = createAsyncThunk(
    'wallet/getNewWalletTransactions',
    async (_, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/wallet-transactions/new-wallet-transaction`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);